var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "asset=Policy, colour=NeutralSubdued, htmlTag=img, assetKey=Content, state=Selected"
  }, /*#__PURE__*/React.createElement("path", {
    id: "assignment",
    d: "M5.49141 21.7998C4.94141 21.7998 4.47058 21.604 4.07891 21.2123C3.68724 20.8206 3.49141 20.3498 3.49141 19.7998V5.7998C3.49141 5.2498 3.68724 4.77897 4.07891 4.3873C4.47058 3.99564 4.94141 3.7998 5.49141 3.7998H9.69141C9.90808 3.1998 10.2706 2.71647 10.7789 2.3498C11.2872 1.98314 11.8581 1.7998 12.4914 1.7998C13.1247 1.7998 13.6956 1.98314 14.2039 2.3498C14.7122 2.71647 15.0747 3.1998 15.2914 3.7998H19.4914C20.0414 3.7998 20.5122 3.99564 20.9039 4.3873C21.2956 4.77897 21.4914 5.2498 21.4914 5.7998V19.7998C21.4914 20.3498 21.2956 20.8206 20.9039 21.2123C20.5122 21.604 20.0414 21.7998 19.4914 21.7998H5.49141ZM7.49141 17.7998H14.4914V15.7998H7.49141V17.7998ZM7.49141 13.7998H17.4914V11.7998H7.49141V13.7998ZM7.49141 9.7998H17.4914V7.7998H7.49141V9.7998ZM12.4914 5.0498C12.7081 5.0498 12.8872 4.97897 13.0289 4.8373C13.1706 4.69564 13.2414 4.51647 13.2414 4.2998C13.2414 4.08314 13.1706 3.90397 13.0289 3.7623C12.8872 3.62064 12.7081 3.5498 12.4914 3.5498C12.2747 3.5498 12.0956 3.62064 11.9539 3.7623C11.8122 3.90397 11.7414 4.08314 11.7414 4.2998C11.7414 4.51647 11.8122 4.69564 11.9539 4.8373C12.0956 4.97897 12.2747 5.0498 12.4914 5.0498Z",
    fill: "#2F3846"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolicy);
export default __webpack_public_path__ + "static/media/Policy.1ebe66f1ce10fef9c2ba32cc478fd97b.svg";
export { ForwardRef as ReactComponent };